import React, { useContext } from 'react'
import Container from '@components/Container'
import {
  CONTAINER_STYLE,
  BUTTON_TYPE,
  PANELS,
  USER_ROLES,
} from '@helpers/constants'
import SubHeader from '@views/SubHeader'
import Button from '@components/Button'
import {
  Route,
  useLocation,
  Routes,
  Navigate,
} from 'react-router-dom'
import Books from './Books'
import Sections from './Sections'
import { AppContext } from '@state/context'
import ContentFilter from '@components/ContentFilter'
import { openPanel } from '@state/actions/panelsActions'
import withTooltip from '@components/WithTooltip'
import { useOwnBooksAllowed } from '@hooks/useOwnBooksAllowed'

const ButtonWithTooltip = withTooltip(Button)

const MyBookcase = () => {
  const { pathname } = useLocation()
  const [state, dispatch] = useContext(AppContext)
  const userRole = state?.app?.userRole
  const ownBooksAllowed = useOwnBooksAllowed()

  return (
    <>
      <SubHeader>
        <SubHeader.MiddleSection>
          {ownBooksAllowed && (
            <>
              <ButtonWithTooltip
                type={BUTTON_TYPE.SECONDARY_OUTLINE}
                to={`bocker`}
                active={pathname === `/bokhylla/bocker`}
                margin
                tooltip={'Dina sparade dokletböcker och egna böcker.'}
              >
                Böcker
              </ButtonWithTooltip>
              <ButtonWithTooltip
                type={BUTTON_TYPE.SECONDARY_OUTLINE}
                to={`avsnitt`}
                active={pathname === `/bokhylla/avsnitt`}
                margin
                tooltip={'Dina sparade avsnitt.'}
              >
                Avsnitt
              </ButtonWithTooltip>
              <ButtonWithTooltip
                type={BUTTON_TYPE.PRIMARY}
                icon={'PlusCircle'}
                handleClick={() => {
                  dispatch(openPanel(PANELS.CREATE_BOOK))
                }}
                iconLeft
                margin
                tooltip={'Skapa en bok och lägg till avsnitt.'}
              >
                Skapa en bok
              </ButtonWithTooltip>
            </>
          )}

          {userRole === USER_ROLES.ADMIN && (
            <Button
              handleClick={() => {
                dispatch(openPanel(PANELS.CREATE_SECTION))
              }}
              type={BUTTON_TYPE.PRIMARY}
              icon={'PlusCircle'}
              iconLeft
              margin
            >
              Skapa ett avsnitt
            </Button>
          )}
        </SubHeader.MiddleSection>

        <SubHeader.RightSection>
          <ContentFilter />
        </SubHeader.RightSection>
      </SubHeader>

      <Container size={CONTAINER_STYLE.DESKTOP}>
        <Routes>
          <Route
            path={`avsnitt`}
            element={
              ownBooksAllowed ? <Sections /> : <Navigate to="../bocker" replace />
            }
          />
          <Route path={`bocker`} element={<Books />} />
          <Route path={''} element={<Navigate to="bocker" replace />} />
        </Routes>
      </Container>
    </>
  )
}

export default MyBookcase
